import {
  Box,
  Card,
  Container,
  Button,
  styled,
  Typography
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const MainContent = styled(Box)(
  () => `
    height: 100%;
    display: flex;
    flex: 1;
    flex-direction: column;
`
);

const TopWrapper = styled(Box)(
  ({ theme }) => `
  display: flex;
  width: 100%;
  flex: 1;
  align-items: center;
  justify-content: center;
  padding: ${theme.spacing(6)};
`
);

function Status404() {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>{t('not.found.page.title')}</title>
      </Helmet>
      <MainContent>
        <TopWrapper>
          <Container maxWidth="md">
            <Box textAlign="center">
              <img
                alt="404"
                height={180}
                src="/static/images/status/404.svg"
                style={{ maxWidth: '100%', height: 'auto', maxHeight: 180 }}
              />
              <Typography variant="h2" sx={{ my: 2 }}>
                {t('not.found.page.message')}
              </Typography>
            </Box>
            <Container maxWidth="sm">
              <Card sx={{ textAlign: 'center', mt: 3, p: 4 }}>
                <Button href="/" variant="outlined">
                  {t('go.to.homepage')}
                </Button>
              </Card>
            </Container>
          </Container>
        </TopWrapper>
      </MainContent>
    </>
  );
}

export default Status404;
